export default __webpack_public_path__ + "static/media/dashboard.8bd8bd09.svg";